import { render, staticRenderFns } from "./UserProtocol.vue?vue&type=template&id=a753038c&scoped=true"
import script from "./UserProtocol.vue?vue&type=script&lang=js"
export * from "./UserProtocol.vue?vue&type=script&lang=js"
import style0 from "./UserProtocol.vue?vue&type=style&index=0&id=a753038c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a753038c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a753038c')) {
      api.createRecord('a753038c', component.options)
    } else {
      api.reload('a753038c', component.options)
    }
    module.hot.accept("./UserProtocol.vue?vue&type=template&id=a753038c&scoped=true", function () {
      api.rerender('a753038c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P3_Page/Docs/kiko/UserProtocol.vue"
export default component.exports